module.exports = __webpack_public_path__ + "static/media/checkmarkOff_326.b76e1397.png";